module.exports = {

    toProperCase(s) {
        s = s || ''
        return s.toLowerCase().replace(/^(.)|\s(.)/g, function($1) {
            return $1.toUpperCase()
        })
    }

}